<template>
  <el-dialog :width="width" :title="dataInfo.title" :visible="dataInfo.visible" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" @open="dialogOpen" :before-close="dialogClose" :append-to-body="isInner">
    <div class="dialog_body_content">
      <slot name="dialog-body-content"></slot>
    </div>
    <div slot="footer" class="dialog_footer_content">
      <slot name="dialog-footer-content"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "75%",
    },
    isInner: {
      type: Boolean,
      default: false,
    },
    dataInfo: {
      type: Object,
      default: function () {
        return {
          title: "编辑窗口",
          id: "",
          visible: false,
        };
      },
    },
  },
  methods: {
    dialogOpen() {
      let data = this.dataInfo;
      this.$emit("dialogOpen", data);
    },
    dialogClose() {
      this.$emit("dialogClose", {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./dialog.scss");
</style>
